export class AlertDialogOptions
{
    constructor(
        public title: string,
        public message: string,
        public buttonText: string
    )
    {

    }
}